import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  ScrollView,
  Platform,
  Dimensions,
  Image,
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import StatusBar from "../../components/headers/StatusBar";
import FooterBarWide from "../../components/footerBarWide";
import MenuBar from "../../components/headers/MenuBar";
import BackButton from "../../components/BackButton";

export default function InvestInfoScreen({ route }) {
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollArea}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="4" />
            <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
              <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
                <View style={GlobalStyles.headerTextYellowForweb}>
                  <View style={GlobalStyles.backIconContainerForWeb} >
                    <BackButton />
                  </View>
                  <View>
                    <Text style={GlobalStyles.headingStyle}>Cash Account Details</Text>
                    <Text style={GlobalStyles.subheaderStyleWeb}>Watch your cashback add up.</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View>
            <StatusBar data="BM" />
            <View style={GlobalStyles.fullHeaderBarW}>
              <View style={GlobalStyles.headerContainerKL}>
                <View style={GlobalStyles.headerText}>
                  <Text style={GlobalStyles.headingStyle}>Cash Account Details</Text>
                  <Text style={GlobalStyles.subheaderStyle}>
                    Watch your cashback add up.
                  </Text>
                </View>
              </View>
            </View>
          </View>)}
        <View style={GlobalStyles.bodyContainer}>
          <View style={styles.bodySectionContainer}>
            <Text style={styles.headerSectionText}>Cash</Text>
            <Text style={styles.textSectionStyle}>
              With every approved transaction you can watch your savings add up.
              Keep shopping the latest offers and Aura will reward you with real
              money which you can choose to save or withdraw.
            </Text>
            <Image
              source={require("../../assets/images/invest/people.jpg")}
              style={styles.smallLogo}
              resizeMode="contain"
            />
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}
const imageWidth = Platform.OS != "web" ? 300 : 800
const imageHeight = Platform.OS != "web" ? 200 : 560
const styles = StyleSheet.create({
  scrollArea: {
    flex: 1,
  },
  textSectionStyle: {
    color: "#333333",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    lineHeight: 20,
    marginBottom: 50,
    marginTop: 20,
  },
  headerSectionText: {
    color: "#333333",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 16,
  },
  bodySectionContainer: {
    paddingTop: 15,
    maxWidth: 800,
    alignSelf: "center",
  },
  hiddenViewButtonContainer: {
    flex: 1,
    flexDirection: "row",
    marginTop: 11,
  },
  lineStyle: {
    borderBottomColor: "black",
    borderBottomWidth: StyleSheet.hairlineWidth,
    marginTop: 25,
  },
  arrowContainer: {
    flex: 1,
    alignSelf: "center",
    alignItems: "flex-end",
  },
  textHeaderContainer: {
    flex: 10,
    alignItems: "flex-start",
    alignSelf: "center",
  },
  smallLogo: {
    width: imageWidth,
    height: imageHeight,
    alignSelf: "center",
  },
});
